import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import { isTeam } from 'components/sports/fen/helper/FenHelpers'
import { findArray } from 'helpers/utils'
import { getSportCodeEntityObjects } from 'components/common/SportCode'
import Label from "components/general/Label";
import SportCode from "components/common/SportCode";
import PageHeader from "components/common/PageHeader";
import NotAvailable from "components/common/NotAvailable";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

// Individual play by play
import FenIndividual from 'components/sports/fen/views/FenIndividual'

// Teams play by play
import FenTeams from 'components/sports/fen/views/FenTeams'

const FenContext = () => {
  const { mirs_rsc, mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
  const queryClient = useQueryClient();
  const [periodsOrder, setPeriodsOrder] = useState()
  useEffect(() => {
    const dataSportCodes = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
    const periodsCodes = getSportCodeEntityObjects(dataSportCodes, mirs_discipline, '@Period');
    const periodsOrder_ = periodsCodes ? periodsCodes?.map(p => ({ period: p.sportCode, order: parseInt(p.order) }))?.sort((a, b) => a.order - b.order) : [];
    setPeriodsOrder(periodsOrder_)
  }, [])

  // results data
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getResultRSC_H2H,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    });

  if (isError) { return <NotAvailable /> }
  if (isLoading || !periodsOrder) { return <Loader /> }
  if (!data?.results) { return <NotAvailable /> }

  let score;
  let homeWLT = findArray(data?.results?.items, { startSortOrder: [1] }).resultWLT;
  let awayWLT = findArray(data?.results?.items, { startSortOrder: [2] }).resultWLT;

  let showdeision;
  let matchDuration = findArray(data?.results?.extendedInfos, { ei_code: ['DURATION_NORMAL'] })?.ei_value;
  let matchOvertime = findArray(data?.results?.extendedInfos, { ei_code: ['DURATION_OVERTIME'] })?.ei_value;
  if (matchDuration) {
    matchDuration = <><Label data='HeaderBoutDuration' />: {matchDuration}</>
  }

  if (matchOvertime) {
    matchOvertime = <><Label data='HeaderOvertime' />: {matchOvertime}</>
  }

  if (homeWLT === 'V(T)' || awayWLT === 'V(T)') {
    showdeision = <>
      <div className='score-horizontal-extra-information-box'>
        <SportCode discipline={mirs_discipline} entity='@WLT' code='V(T)' />
      </div>
    </>
  }

  let period = <SportCode discipline={mirs_discipline} entity='@Period' code={findArray(data?.results?.extendedInfos, { ei_code: ['LAST_COMP'] })?.ei_pos} />

  score = <ScoreHorizontal
    data={data}
    scoreBody={{
      top: period,
      bottom: showdeision
    }}
    scoreFooter={{
      bottom: <>{matchDuration} {matchOvertime}</>
    }
    }
  />

  return (
    <>
      <PageHeader data={data} />
      <div className='mirs-page-container'>
      <div className='my-5'>
        {score}
      </div>
      {!isTeam(mirs_rsc) && <FenIndividual data={data} periodsOrder={periodsOrder} />}
      {isTeam(mirs_rsc) && <FenTeams data={data} periodsOrder={periodsOrder} />}
      </div>
    </>
  );
};

export default FenContext;
